export default "__VITE_ASSET__DvSQJGoD__"